<template>
  <div class="animated fadeIn list-of-coa">
    <b-card>
      <div slot="header">Dimension Value
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="refresh()"><i class="fa fa-refresh"></i> Refresh</button>
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="btn btn-primary" @click="close">Close</b-button>
        </div>
      </div>
      <b-row>
        <b-col lg="3">
              <b-form-group label-cols=5 label="Dimension Name">
                <b-form-select v-model="tblData.DimColName" :plain="true" :options="dimension"></b-form-select>
              </b-form-group>
        </b-col>
        <b-col lg="4">
          <b-form-group label-cols=3 label="Dimension Value">
            <b-row>
                <b-col cols="4">
                  <b-form-input v-model="tblData.kode" placeholder="code"></b-form-input>
                </b-col>
                <b-col cols="8">
                  <b-form-input v-model="tblData.nama" placeholder="name"></b-form-input>
                </b-col>
            </b-row>
          </b-form-group>
        </b-col>
        <b-col lg="3">
          <b-form-group label-cols=5 label="Dim. Value Active ">
             <b-form-select v-model="tblData.aktif" :plain="true" :options="YesNoAll"></b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        striped hover
        :items="data"
        :fields="tblData.fields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
      >

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <b-modal v-model="showForm" header-bg-variant="primary"  :title="formTitle" :centered="true" @ok="handleOk">
      <!-- <b-form @submit.stop.prevent="handleOk"> -->
          <b-input-group >
              <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="model.DimColName" :plain="true" :options="dimension" :state="!$v.model.DimColName.$error"></b-form-select>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>Dim. Value Code</label></b-input-group-prepend>
              <b-form-input v-model="model.kode" :state="!$v.model.kode.$error"></b-form-input>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>Dim. Value Name</label></b-input-group-prepend>
              <b-form-input v-model="model.nama" :state="!$v.model.nama.$error"></b-form-input>
          </b-input-group>
          <b-input-group >
              <b-input-group-prepend><label>Dim. Value Active</label></b-input-group-prepend>
             <b-form-select v-model="model.aktif" :plain="true" :options="YesNoAll"></b-form-select>
          </b-input-group>
      <!-- </b-form> -->
    </b-modal>

    </b-card>

  </div>
</template>

<style lang="scss">
.list-of-coa {
iframe {
  border: 1px solid #ccc;
  width: 100%;
  height: 11in;
}

}
</style>


<script>
import toastr from "mini-toastr";
import dropdown from "../../data/dropdown";
import coa from "../../apis/dimensionsample";
import { validationMixin } from "vuelidate";
import { required, maxLength,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    // model: {
    //   kode: {
    //     required,
    //      maxLength: maxLength(50)
    //   },
    //   nama: {
    //     required,
    //      maxLength: maxLength(100)
    //   },
    //   DimColName: { required },
    // }
    model: {
      nama: { required },
      kode: { required },
      DimColName: { required },
    }
  },    
data() {
    return {
      formTitle: 'Add - Dimension Value',
      showForm:false,
      saveEnabled: true,
      showDelConfirm: false,
      horizontal: true,
      model:{kode: '', nama: '',  DimColName: ''},
      striped: false,
      tblData: {
        items: [],
        fields: [
          {
            key: "DimColName",
            thStyle: "width:150px",
            label: "Dimension Code "
          },
          {
            key: "DimColDesc",
            label: "Dimension Name",
            thStyle: "width:250px",
            sortable: true
          },
          {
            key: "kode",
            label: "Value Code",
            thStyle: "width:200px",
            sortable: true
          },
          {
            key: "nama",
            label: "Value Name",
            sortable: true
          },
          {
            key: "aktif",
            label: "Active?",
            thStyle: "width:100px",
            tdClass: "text-center"
          },
          {
            key: "action",
            label: "Action",
            thClass: "text-center",
          },

        ],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        kode: "",
        nama: "",
        DimColName: "Dim1", DimColInfo:'Department'
      },
      YesNo:dropdown.YesNo,
      YesNoAll:dropdown.YesNoAll,
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
   filterDimension() {
      return this.tblData.DimColName;
    },
    filterKode() {
      return this.tblData.kode;
    },
    filterNama() {
      return this.tblData.nama;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },    
  },
  watch: {
    filterDimension: function(DimColName) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (DimColName == tblData.DimColName){
          this.tblData.DimColInfo=this.dimension.find(d => d.value === DimColName).text;
          refresh();
        } 
      }, 500);
    },
    filterKode: function(kode) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (kode == tblData.kode) refresh();
      }, 500);
    },
    filterNama: function(nama) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (nama == tblData.nama) refresh();
      }, 500);
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
    //   this.tblData.nama = this.tblData.filter;

      const list = await coa.list(this.tblData);      
      return list;
    },
    add: function() {
      this.$v.model.$reset();
      this.model.kode= '';
      this.model.nama='' ;

      this.formTitle='Add - Dimension Value';
      this.showForm = true;
    },
    edit: function(data) {
      for (var key in data) {
          this.model[key] = data[key];
      }      
      this.model.kodelama=data.kode;
      this.formTitle='Edit - Dimension Value';
      this.showForm = true;
      this.$v.model.$reset();
    },
    deleteConfirm(data) {
      for (var key in data) {
          this.model[key] = data[key];
      }      
      this.showDelConfirm = true;
    },
    handleOk: function(evt) {
      evt.preventDefault()
      if (this.invalidModel) {
          const invalidobj = {};
            for (var key in this.$v.model) {
            if (this.$v.model[key].$anyError) {
                if (this.$v.model[key].$anyError == true) invalidobj[key] = this.$v.model[key];
            }
            }
            console.log('validation model: ', this.model);
            console.log('validation field: ', invalidobj);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
       } else {
        this.save()
      }
    },
    save: async function() {
      if (!this.saveEnabled) {
          return;
      }
      this.saveEnabled=false;            
      const { model } = this;
        try {
          if (this.formTitle == "Add - Dimension Value") {
            await coa.insert(model);
          } else {
            await coa.update(model);
          }
          this.showForm = false;
          this.saveEnabled=true;            
          this.refresh();
        } catch (error) {
          this.saveEnabled=true;            
          console.log('save : ', error)
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
          this.saveEnabled=true;            
        }
    },
    deleteData: async function() {
        try {
            await coa.remove(this.model);
            this.refresh();
        } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            await coa.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
        }
    },
    refresh() {
      this.$refs.table.refresh();
    },
    close(){
      router.push({ path:"home" });
    }    
  }
};
</script>
